import { CustomFilterTable } from './CustomFilterTable';

export default CustomFilterTable;
